import { render, staticRenderFns } from "./SalesInvoices.vue?vue&type=template&id=5c0b96f8&scoped=true"
import script from "./SalesInvoices.vue?vue&type=script&lang=ts"
export * from "./SalesInvoices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0b96f8",
  null
  
)

export default component.exports